module.exports = {
  fallback: 'حل تحدي الكابتشا.',
};
